//import { Enviroment } from "../../../enviroments";
import CookieService from "../../autenticacao/CookieService";
import { Api } from "../axios-config"

export interface IDadosPremiacao {
    codigo: number;
    descricao: string;
    quantidade: number;
    codigo_Liga: number;
    codigo_Temporada: number;
    codigo_Premiacao: number;
    valor_Usuario: number;
    valor_Total: number;
    dtCriacao: Date;
    codUsuCriacao: number;
}

export interface IListaDadosDetalheFinanceiro {
    codigo_Unico: number;
    codigo: number;
    codigo_Liga: number;
    codigo_Temporada: number;
    codigo_Usuario: number;
    codigo_Franquia: number;
    nome_Usuario: string;
    foto_Usuario: string;
    nome_Franquia: string;
    logo_Franquia: string;
    valor: string;
    situacao: boolean;
    status: number;
    desconto: string;
    observacao: string;
    descricao_Temporada: string;
    nome_Liga: string;
    logo_Liga: string;
    dtSolicitacao: Date;
    dtGeracao: Date;
    dtPagamento: Date;
    dtBaixa: Date;
    forma_Pagamento: number;
    premiacao: boolean;
    valor_Usuario: number;
    tipo: number;
    descricao_Tipo: string;
    premiacao_Liga: IDadosPremiacao[];
}

export interface IDadosRetornoFinanceiro {
    dado: IListaDadosFinanceiro;
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IListaDadosFinanceiro {
    codigo_Usuario: number;
    nome_Usuario: string;
    residencia_Exterior: boolean;
    foto_Usuario: string;
    desconto_Comissario: boolean;
    desconto_Indicacao: boolean;
    quantidade_Liga: number;
    valor_Liga: string;
    valor_Total_Liga: string;
    valor_Pago: string;
    desconto_Pago: string;
    valor_Restante: string;
    detalhes_Financeiro_Liga: IListaDadosDetalheFinanceiro[];
    detalhes_Premiacao_Liga: IDadosPremiacao[];
    detalhes_Pagamento_Liga: IDadosPagamentoLiga[];
}

export interface IDadosPagamentoLiga {
    codigo_Unico: number;
    qr_Code_Pix: string;
    copia_Cola_Pix: string;
    codigo_Barra_Boleto: string;
    caminho_Arquivo_Boleto: string;
    codigo_Forma_Pagamento: number;
    url_Checkout: string | null;
}

export interface IListaDadosCadastroFinanceiro {
    //codigo: number;
    codigo_Temporada: number;
    codigo_Usuario: number;
    codigo_Liga: number;
    codigo_Franquia: number;
    codigo_Premiacao: number;
    forma_Pagamento: number;
    situacao: boolean;
    status: number;
    valor: number;
    desconto: number;
    observacao?: string;
    dtCriacao?: Date;
    codUsuCriacao?: number;

}


export interface IDadosCadastroFinanceiro {
    codigo_Temporada: number;
    codigo_Usuario: number;
    codigo_Liga: number;
    codigo_Franquia: number;
    forma_Pagamento: number;
    codigo_Premiacao: number;
    situacao: boolean;
    status: number;
    valor: number;
    desconto: number;
    observacao?: string;
    codUsuCriacao: number;
    nome_Usuario?: string;
}


export interface IDadosCreateFinanceiro {
    codigo_Usuario: number;
    forma_Pagamento: number;
    nome: string;
    cpf: string;
    dados_Financeiro: IListaDadosCadastroFinanceiro[]
}

export interface IDadosRetornoArquivo {
    data: {
        dado: IDadosRespArquivo[];
        erros: string;
        mensagem: string;
        processado: boolean;
        status: number;
        statusHTTP: number;
    }
}


export interface IDadosRespArquivo {
    caminho: string;
    nome: string;
    nomeReal: string;
}

export interface IDadosSalvarArquivos {
    codigo_Liga: number;
    codigo_Temporada: number;
    codigo_Usuario: number;
    nome: string;
    codUsuCriacao: number;
}

export interface IDadosRetornoArquivosFinanceiro {
    dado: IDadosArquivos[];
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IDadosArquivos {
    codigo: number;
    codigo_Liga: number;
    codigo_Temporada: number;
    codigo_Usuario: number;
    caminho: string;
    nome: string;
    codUsuCriacao: number;
}


export interface IDadosRetornoValoresFinanceiro {
    dado: IDadosValor
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IDadosValor {
    codigo: number;
    valor: number;
    valor_Unitario: number;
    tipo: number;

}


export interface IDadosBaixaFinanceiro {
    codigo: number;
    codUsuModificacao: number;
    nomeUsuario?: string;
}


export interface IListaDadosRetornoFinanceiro {
    dado: IListaDadosDetalheFinanceiro[];
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IRetornoUsuarioInadiplente {
    dado: boolean;
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IRetornoUrl {
    dado: string;
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IDadosRetornoSolicitacaoPagamento {
    dado: IDadosSolicitacaoPagamento;
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    mensagem: string;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}


export interface IDadosSolicitacaoPagamento {
    codigos_Financeiros: number[];
    codigo_Pix: number;
    qr_Code_Pix: string;
    copia_Cola_Pix: string;
    codigo_Boleto: number;
    codigo_Barra_Boleto: string;
    caminho_Arquivo_Boleto: string;
    codigo_Checkout: number;
    url_Checkout: string;
}


const getAllDetalhesPagamentos = async (): Promise<IDadosRetornoFinanceiro> => {
    const token = CookieService.get("access_token");
    const user = CookieService.get("access_user");
    const { data } = await Api.get<IDadosRetornoFinanceiro>(`/financeiro/detalhes/${user.codUsuario}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getDadosFinanceiroPorUsuario = async (codigoUsuario: number, codigoTemporadaFiltro: number = 0, codigoTipoLigaFiltro: number = 0): Promise<IDadosRetornoFinanceiro> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoFinanceiro>(`/financeiro/usuario/detalhes`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        },
        params: {
            codigo_Usuario: codigoUsuario,
            codigo_Temporada: codigoTemporadaFiltro === 0 ? null : codigoTemporadaFiltro,
            codigo_Tipo: codigoTipoLigaFiltro === 0 ? null : codigoTipoLigaFiltro,
        }
    });
    return data;
}

const getArquivosFinanceiro = async (codigoUsuario: number, codigoTemporada: number): Promise<IDadosRetornoArquivosFinanceiro> => {
    const token = CookieService.get("access_token");

    const { data } = await Api.get<IDadosRetornoArquivosFinanceiro>(`/financeiro/arquivo/${codigoUsuario}/${codigoTemporada}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getValoresFinanceiro = async (quantidadeliga: number, tipo: number): Promise<IDadosRetornoValoresFinanceiro> => {
    const token = CookieService.get("access_token");

    const { data } = await Api.get<IDadosRetornoValoresFinanceiro>(`/financeiro/preco/${quantidadeliga}/${tipo}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getDadosFinanceiroPorLiga = async (codigoLiga: number, codigoTemporada: number): Promise<IListaDadosRetornoFinanceiro> => {
    const token = CookieService.get("access_token");

    const { data } = await Api.get<IListaDadosRetornoFinanceiro>(`/financeiro/liga/${codigoLiga}/${codigoTemporada}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}


const Create = async (dados: IDadosCreateFinanceiro): Promise<IDadosRetornoSolicitacaoPagamento> => {

    const token = CookieService.get("access_token");
    const { data } = await Api.post(`/financeiro`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    }
    );

    return data;
}

const CreateBaixaPagamento = async (dados: IDadosCadastroFinanceiro): Promise<number | Error> => {

    const token = CookieService.get("access_token");
    const { data } = await Api.post(`/financeiro/pago`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    }
    );

    return data;
}

const createFiles = async (lstDados: IDadosSalvarArquivos[]): Promise<number | Error> => {

    const token = CookieService.get("access_token");
    const { data } = await Api.post(`/financeiro/arquivo`, lstDados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    }
    );

    return data;
}

const updateById = async (codigo: number, dados: IListaDadosDetalheFinanceiro): Promise<void | Error> => {
    try {
        const token = CookieService.get("access_token");
        await Api.put<IListaDadosDetalheFinanceiro>(`/financeiro/${codigo}`, dados, {
            headers: {
                "Access-Control-Allow-Origin": "*",
                "chavesessao": token
            }
        });
    } catch (error) {
        return new Error((error as { message: string }).message || "Erro ao atualizar o cidade");
    }

}

const deleteById = async (codigo: number, codigoUsuario: number): Promise<void | Error> => {
    try {
        const token = CookieService.get("access_token");
        await Api.delete(`/financeiro/arquivo/${codigo}/${codigoUsuario}`, {
            headers: {
                "Access-Control-Allow-Origin": "*",
                "chavesessao": token
            }
        });
    } catch (error) {
        return new Error((error as { message: string }).message || "Erro ao excluir o arquivo");
    }
}

const upLoadFiles = async (files: any[]): Promise<IDadosRetornoArquivo> => {
    const formData = new FormData();
    files.forEach((file, i) => {
        formData.append(`files`, file);
    });

    const token = CookieService.get("access_token");
    return await Api.post('/FileUpload/financeiro/pagamento/upload', formData, {
        headers: {
            "Content-Type": "multipart/form-data",
            'Access-Control-Allow-Origin': '*',
            'chavesessao': token
        }
    }).then(res => res)
        .catch((error) => error.response);

}

const updateByFinanceiroId = async (dados: IDadosBaixaFinanceiro): Promise<number | Error> => {

    const token = CookieService.get("access_token");
    const { data } = await Api.put(`/financeiro/finalizar`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    }
    );

    return data;
}

const getUsuarioInadimplente = async (codigoLiga: number, codigoTemporada: number): Promise<IRetornoUsuarioInadiplente> => {
    const token = CookieService.get("access_token");

    const { data } = await Api.get<IRetornoUsuarioInadiplente>(`/financeiro/usuario/inadimplente/${codigoLiga}/${codigoTemporada}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getUrlPagamento = async (codigo: number): Promise<IRetornoUrl> => {
    const token = CookieService.get("access_token");

    const { data } = await Api.get<IRetornoUrl>(`/financeiro/url/${codigo}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

export const FinanceiroService = {
    getDadosFinanceiroPorUsuario,
    getAllDetalhesPagamentos,
    Create,
    updateById,
    deleteById,
    upLoadFiles,
    createFiles,
    getArquivosFinanceiro,
    getValoresFinanceiro,
    updateByFinanceiroId,
    CreateBaixaPagamento,
    getDadosFinanceiroPorLiga,
    getUsuarioInadimplente,
    getUrlPagamento,
    
}